import {IMGPW} from '@/config';
import Image from 'next/image';

interface ImageTextSectionProps {
  children: any;
  title: string;
  imageUrl?: string;
  imageOrder?: string;
}

export const ImageTextSection = ({
  children,
  title,
  imageUrl,
  imageOrder,
}: ImageTextSectionProps) => {
  return (
    <>
      <div className="row align-items-center pb-3 pt-3">
        {imageUrl && (
          <div
            className={`col-md-5 ${imageOrder === 'right' ? 'order-md-2' : ''}`}
          >
            <Image
              className="d-block m-auto img-fluid"
              height={350}
              width={350}
              src={IMGPW + '/' + imageUrl}
              style={{maxHeight: '350px'}}
              alt={title}
            />
          </div>
        )}
        <div
          className={`${imageUrl ? 'col-md-7' : 'col'} text-md-left ${
            imageOrder === 'right' ? 'order-md-1' : ''
          }`}
        >
          <div className="mt-30 hidden-md-up"></div>
          <h1>
            <b>{title}</b>
          </h1>
          {children}
        </div>
      </div>
      <hr />
    </>
  );
};
